export default function Campaign() {
  return (
    <section className="py-20 bg-gradient-to-br from-[#FFF5F0] via-[#FFE8DC] to-[#FFF8F3]">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-12">
          <div className="inline-flex items-center gap-2 bg-[#FF9B8A]/20 px-6 py-2 rounded-full mb-4">
            <i className="ri-gift-line text-[#FF9B8A] text-xl w-5 h-5 flex items-center justify-center"></i>
            <span className="text-[#6B4E3D] font-semibold text-sm">期間限定キャンペーン</span>
          </div>
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
            今だけの特別価格 🌸
          </h2>
          <p className="text-gray-700 text-lg">
            より多くの方にセラピーを体験していただきたいから
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-8 max-w-5xl mx-auto">
          {/* First Time Campaign */}
          <div className="bg-white rounded-3xl p-8 shadow-lg hover:shadow-xl transition-all duration-300 border-2 border-[#FFD93D]/30 relative overflow-hidden group">
            <div className="absolute top-0 right-0 w-32 h-32 bg-[#FFD93D]/10 rounded-full -mr-16 -mt-16 group-hover:scale-150 transition-transform duration-500"></div>
            
            <div className="relative">
              <div className="w-16 h-16 bg-[#FFD93D]/20 rounded-2xl flex items-center justify-center mb-6">
                <i className="ri-star-line text-[#FFD93D] text-3xl w-8 h-8 flex items-center justify-center"></i>
              </div>
              
              <h3 className="text-2xl font-bold text-gray-900 mb-3">
                はじめての方限定
              </h3>
              
              <div className="flex items-baseline gap-3 mb-6">
                <span className="text-5xl font-bold text-[#FF9B8A]">¥2,000</span>
                <span className="text-2xl text-gray-400 line-through">¥3,000</span>
              </div>
              
              <div className="space-y-3 mb-8">
                <div className="flex items-start gap-3">
                  <i className="ri-check-line text-[#6B4E3D] text-xl w-5 h-5 flex items-center justify-center mt-0.5"></i>
                  <span className="text-gray-700">40分間のオンラインセッション</span>
                </div>
                <div className="flex items-start gap-3">
                  <i className="ri-check-line text-[#6B4E3D] text-xl w-5 h-5 flex items-center justify-center mt-0.5"></i>
                  <span className="text-gray-700">Google Meetで安心・安全</span>
                </div>
                <div className="flex items-start gap-3">
                  <i className="ri-message-3-line text-[#FF9B8A] text-xl w-5 h-5 flex items-center justify-center mt-0.5"></i>
                  <span className="text-gray-700"><strong>口コミ投稿必須</strong></span>
                </div>
              </div>
              
              <button 
                onClick={() => document.getElementById('booking')?.scrollIntoView({ behavior: 'smooth' })}
                className="w-full bg-[#6B4E3D] hover:bg-[#5A3F2E] text-white px-8 py-4 rounded-full font-semibold transition-all shadow-md hover:shadow-lg whitespace-nowrap cursor-pointer"
              >
                今すぐ予約する →
              </button>
            </div>
          </div>

          {/* Repeat Customer Campaign */}
          <div className="bg-white rounded-3xl p-8 shadow-lg hover:shadow-xl transition-all duration-300 border-2 border-[#FF9B8A]/30 relative overflow-hidden group">
            <div className="absolute top-0 right-0 w-32 h-32 bg-[#FF9B8A]/10 rounded-full -mr-16 -mt-16 group-hover:scale-150 transition-transform duration-500"></div>
            
            <div className="relative">
              <div className="w-16 h-16 bg-[#FF9B8A]/20 rounded-2xl flex items-center justify-center mb-6">
                <i className="ri-heart-line text-[#FF9B8A] text-3xl w-8 h-8 flex items-center justify-center"></i>
              </div>
              
              <h3 className="text-2xl font-bold text-gray-900 mb-3">
                リピーター様特別価格
              </h3>
              
              <div className="flex items-baseline gap-3 mb-6">
                <span className="text-5xl font-bold text-[#FF9B8A]">¥1,500</span>
                <span className="text-2xl text-gray-400 line-through">¥3,000</span>
              </div>
              
              <div className="space-y-3 mb-8">
                <div className="flex items-start gap-3">
                  <i className="ri-check-line text-[#6B4E3D] text-xl w-5 h-5 flex items-center justify-center mt-0.5"></i>
                  <span className="text-gray-700">40分間のオンラインセッション</span>
                </div>
                <div className="flex items-start gap-3">
                  <i className="ri-check-line text-[#6B4E3D] text-xl w-5 h-5 flex items-center justify-center mt-0.5"></i>
                  <span className="text-gray-700">継続的なサポートをお得に</span>
                </div>
                <div className="flex items-start gap-3">
                  <i className="ri-calendar-line text-[#FF9B8A] text-xl w-5 h-5 flex items-center justify-center mt-0.5"></i>
                  <span className="text-gray-700"><strong>1ヶ月以内の再予約限定</strong></span>
                </div>
              </div>
              
              <button 
                onClick={() => document.getElementById('booking')?.scrollIntoView({ behavior: 'smooth' })}
                className="w-full bg-[#6B4E3D] hover:bg-[#5A3F2E] text-white px-8 py-4 rounded-full font-semibold transition-all shadow-md hover:shadow-lg whitespace-nowrap cursor-pointer"
              >
                リピート予約する →
              </button>
            </div>
          </div>
        </div>

        <div className="text-center mt-12">
          <p className="text-gray-600 text-sm">
            ※ キャンペーン価格は予告なく終了する場合がございます
          </p>
        </div>
      </div>
    </section>
  );
}
